import { fold, isSome, Option } from 'fp-ts/lib/Option';
import { createSelector } from 'reselect';
import { AuthState } from 'state/auth/auth.reducer';
import { AppState } from 'state/reducer';
import JwtDecode from 'jwt-decode';
import { TokenAccountStatus, TokenPayload } from 'models/token';

export const authStateSelector = (state: AppState) => state.auth;

export const tokenSelector = createSelector(
  authStateSelector,
  (state: AuthState) => state.token
);

export const authLoadingSelector = createSelector(
  authStateSelector,
  (state: AuthState) => state.loading
);

export const isAuthenticatedSelector = createSelector(
  tokenSelector,
  (token: Option<string>) => isSome(token)
);

export const tokenPayloadSelector = createSelector(
  tokenSelector,
  fold(
    () => null,
    (data) => {
      return JwtDecode(data) as TokenPayload;
    }
  )
);

export const needPasswordChangeSelector = createSelector(
  tokenSelector,
  fold(
    () => null,
    (data) =>
      (JwtDecode(data) as TokenPayload).accountStatus ===
        TokenAccountStatus.NeedPasswordChange ||
      (JwtDecode(data) as TokenPayload).accountStatus ===
        TokenAccountStatus.Inactive
  )
);

export const needMfaVerificationSelector = createSelector(
  tokenSelector,
  fold(
    () => null,
    (data) =>
      (JwtDecode(data) as TokenPayload).accountStatus ===
      TokenAccountStatus.NeedMfaVerification
  )
);

export const needMfaEnabledSelector = createSelector(
  tokenSelector,
  fold(
    () => null,
    (data) =>
      (JwtDecode(data) as TokenPayload).accountStatus ===
      TokenAccountStatus.NeedMfaEnabled
  )
);

export const usernameSelector = createSelector(
  (state: AppState) => state.auth.username,
  fold(
    () => null,
    (data) => data
  )
);
